<script setup>
import {
  currentModel,
  mutateStringPath,
  getNestedProperty,
} from './currentModel';

function addUpload($attrs) {
  const item = getNestedProperty(currentModel.value, $attrs.x);
  item.push({
    value: null,
    model: `${$attrs.x}.${item.length}.value`,
    label: 'Enter the title',
    editable: true,
  });
}
</script>
<template>
  <div class="flex flex-col gap-1 w-full overflow-hidden" :class="$attrs.class">
    <div class="flex items-center w-full my-4">
      <div class="text-primary font-semibold">Uploads</div>
      <div class="flex flex-1 flex-col justify-center">
        <q-separator inset />
      </div>
      <q-btn
        v-if="$attrs.x"
        color="primary"
        flat
        label="Add New Upload Item"
        noaps
        @click="addUpload($attrs)"
      />
    </div>
    <div v-for="item in $attrs.items" class="flex gap-4">
      <q-input
        class="flex-1"
        :class="[item.editable ? '' : 'pointer-events-none ']"
        :disable="!item.editable"
        outlined
        dense
        v-bind="item"
        :bg-color="item.editable ? '' : 'grey-4'"
        v-model="item.Label"
      />

      <q-file
        class="w-1/2"
        inputClass="h-6 w-full  overflow-hidden"
        label="Choose File"
        outlined
        dense
        :value="getNestedProperty(currentModel, item.model)"
        @input="(v) => mutateStringPath(currentModel, item.model, v)"
      >
        <template #after>
          <div
            class="cursor-pointer text-lg text-primary bg-grey-3 px-4 h-full flex items-center justify-center"
            @click.stop
          >
            Browse
          </div>
        </template>
      </q-file>
    </div>
    <template v-if="$attrs.x">
      <div
        v-for="item in getNestedProperty(currentModel, $attrs.x)"
        class="flex gap-4"
      >
        <q-input
          class="flex-1"
          :class="[item.editable ? '' : 'pointer-events-none ']"
          :disable="!item.editable"
          outlined
          dense
          v-bind="item"
          :bg-color="item.editable ? '' : 'grey-4'"
          v-model="item.Label"
        />

        <q-file
          class="w-1/2"
          inputClass="h-6 w-full  overflow-hidden"
          label="Choose File"
          outlined
          dense
          :value="getNestedProperty(currentModel, item.model)"
          @input="(v) => mutateStringPath(currentModel, item.model, v)"
        >
          <template #after>
            <div
              class="cursor-pointer text-lg text-primary bg-grey-3 px-4 h-full flex items-center justify-center"
              @click.stop
            >
              Browse
            </div>
          </template>
        </q-file>
      </div>
    </template>
  </div>
</template>
